import { SellingTypeEnum } from 'libs/datalayer/src';
import { isEditPage } from '@classifieds-sell/shared';
import { ActivatedRoute } from '@angular/router';
import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, Input } from '@angular/core';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { Subject } from 'rxjs';
import { MotorsSectionBase } from '../motors-section-base';

@Component({
    selector: 'motors-cannot-edit-something-message-section',
    templateUrl: './motors-cannot-edit-something-message-section.component.html',
    styleUrls: ['./motors-cannot-edit-something-message-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MotorsCannotEditSomethingMessageSectionComponent extends MotorsSectionBase
    implements OnInit, OnDestroy {

    @Input() isVehicleDetails: boolean;
    @Input() isListingDetails: boolean;
    @Input() isDescriptionAndPhotos: boolean;

    private _destroyed$: Subject<void> = new Subject<void>();
    message: string;

    constructor(
        draftFacade: MotorsDraftFacade,
        private _activatedRoute: ActivatedRoute
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            if (isEditPage(this._activatedRoute)) {
                const sellingType = this.originalDraftData.listingDetails.sellingType;
                this.message = (sellingType === SellingTypeEnum.classified
                    && this.isDescriptionAndPhotos
                    && this.isListingAfterSevenDays
                    && this.getMessageByStatusListing(false, this.isListingAfterSevenDays))
                    || (sellingType === SellingTypeEnum.auction
                        && (this.isVehicleDetails || this.isListingDetails)
                        && this.isWithBid
                        && this.getMessageByStatusListing(this.isWithBid, false))
                    || (sellingType === SellingTypeEnum.auction
                        && this.isDescriptionAndPhotos
                        && (this.isWithBid || this.isListingAfterSevenDays)
                        && this.getMessageByStatusListing(this.isWithBid, this.isListingAfterSevenDays));
            }
        });
    }

    private getMessageByStatusListing(isWithBid: boolean, isListingAfterSevenDays: boolean) {
        return (isWithBid && isListingAfterSevenDays
            && 'Some details can\'t be changed after your listing has been live for 7 days and/or your auction has bids.')
            || (isWithBid
                && 'Some details can\'t be changed after your listing has bids.')
            || (isListingAfterSevenDays
                && 'Some details can\'t be changed after your listing has been live for 7 days.');
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
